module.exports = __webpack_public_path__ + "img/kagayaki.3e6257f.png";